<template>
  <div class="pb-20">
    <Title 
      :title_default="data.properties.name"
      v-model="data.properties.seo.title"
    />
    <Description 
      :desc_default="data.properties.name"
      v-model="data.properties.seo.description" 
    />
    <Keyword 
      v-model="validate.$model" 
      :validate="validate"
    />
    <hr>
    <SEOPreview :data="data" />
  </div>
</template>

<script>
import Description from "./Input/Description";
import Keyword from "./Input/Keyword";
import Title from "./Input/Title";
import SEOPreview from "./SEOPreview";

export default {
  components: {
    Description,
    Keyword,
    Title,
    SEOPreview,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}; 
      },
    },
    validate: {
      type: Object,
    }
  },
};
</script>

<style></style>